import VimeoController from './vimeo-controller'

function isAttributeTruthy (val) {
  if (val === '') return true
  if (!isNaN(val)) {
    return !!parseInt(val)
  }
  return val.toLowerCase() !== 'false'
}

export default function initVimeoControllerByAttributes (containerElement) {
// Attributes extracted:
// data-vimeo-controller-lazy
// data-vimeo-controller-object-fit
// data-vimeo-controller-click-to-play-pause
// data-vimeo-* options will be handled by the vimeo player itself

  const options = {
    playerOptions: {}
  }

  const attributeId = containerElement.getAttribute('data-vimeo-controller-id')
  if (attributeId != null) {
    options.playerOptions.id = attributeId
  }

  const attributeLazy = containerElement.getAttribute('data-vimeo-controller-lazy')
  if (attributeLazy != null) {
    options.lazy = isAttributeTruthy(attributeLazy)
  }

  const attributeObjectFit = containerElement.getAttribute('data-vimeo-controller-object-fit')
  if (attributeObjectFit != null) {
    options.objectFit = attributeObjectFit
  }

  const attributeClickToPlayPause = containerElement.getAttribute('data-vimeo-controller-click-to-play-pause')
  if (attributeClickToPlayPause != null) {
    options.clickToPlayPause = isAttributeTruthy(attributeClickToPlayPause)
  }

  const vimeoController = new VimeoController(containerElement, options)

  return vimeoController
}
